import { __extends } from "tslib";
import { ValueObject } from '../../../../../base/ddd-types/value-object';
import { ACCOUNT_TYPE } from '@tencent/ark-utils/lib/base/types';
import { BIND_TYPE } from './bind-user-info.interface';
var BindUserInfoObjectValue = /** @class */ (function (_super) {
    __extends(BindUserInfoObjectValue, _super);
    function BindUserInfoObjectValue(userInfo) {
        var _this = _super.call(this) || this;
        _this.type = BIND_TYPE.UNBIND;
        _this.userName = '';
        _this.userPic = '';
        _this.accountType = ACCOUNT_TYPE.UNKNOWN;
        if (userInfo) {
            _this.loginType = userInfo.loginType;
            var bindUserInfo = _this.handleBindUserInfo(userInfo);
            _this.jsonObj2Class(bindUserInfo);
        }
        return _this;
    }
    BindUserInfoObjectValue.prototype.handleBindUserInfo = function (userInfo) {
        var wxAvatar = userInfo.wxAvatar, wxNick = userInfo.wxNick, qqAvatar = userInfo.qqAvatar, qqNick = userInfo.qqNick, wxOpenid = userInfo.wxOpenid;
        if (wxOpenid && this.loginType !== ACCOUNT_TYPE.WX) {
            return {
                type: BIND_TYPE.BINDING,
                userName: wxNick,
                userPic: wxAvatar,
                accountType: ACCOUNT_TYPE.WX,
            };
        }
        if (qqAvatar && this.loginType !== ACCOUNT_TYPE.QQ) {
            return {
                type: BIND_TYPE.BINDING,
                userName: qqNick,
                userPic: qqAvatar,
                accountType: ACCOUNT_TYPE.QQ,
            };
        }
        return {
            type: BIND_TYPE.UNBIND,
            userName: '',
            userPic: '',
            accountType: ACCOUNT_TYPE.UNKNOWN,
        };
    };
    return BindUserInfoObjectValue;
}(ValueObject));
export { BindUserInfoObjectValue };
